import { Box, Text } from "rebass";
import { maxWidth, space } from "styled-system";
import { theme } from "../styles/theme";
import styled from "styled-components";
import { Arrow } from "./arrow";

const Hero = ({ title, description, arrow = true, onButtonClick }) => {
  return (
    <Box pt={[3, 3, 3, 8]} px={[3, 3, 3, 4]} pb={[3, 3, 3, 6]}>
      <Inner mx="auto" maxWidth={0} textAlign="center">
        <Title
          as="h1"
          fontFamily="medium"
          letterSpacing={2}
          fontSize={[5, 5, 7]}
          m={0}
        >
          {title}
        </Title>
        {description && (
          <Text mt={[4, 5, 6]} lineHeight={1.25} fontSize={[2, 3, 4]}>
            {description}
          </Text>
        )}
        {arrow && (
          <StyledArrow
            ariaLabel="Scroll down to next section"
            mt={[4, 5, 6]}
            size={50}
            onClick={onButtonClick}
          />
        )}
      </Inner>
    </Box>
  );
};

const StyledArrow = styled(Arrow)`
  ${space}
  display: inline-block;
`;

const Inner = styled(Text)`
  ${maxWidth}
`;

const Title = styled(Text)`
  text-transform: uppercase;

  p {
    margin: 0;
  }

  p:nth-child(1) {
    font-size: 56%;
  }

  p:nth-child(2) {
    margin-top: 4%;
    font-size: 183%;
  }

  p:last-child {
    margin-top: 4%;

    @media screen and (max-width: ${theme.breakpoints[0]}) {
      font-size: 83%;
    }
  }
`;

export { Hero };
